import React, { useState, useEffect } from 'react';
import './QuestionnaireReadOnly.css';

interface SectionNetworkData {
  sectionId: number;
  sectionName: string;
  TotalQuestions: number;
  NotAnsweredCount: number;
  expanded: boolean;
  questions: QuestionNetworkData[];
}

interface QuestionNetworkData {
  questionId: number;
  questionText: string;
  answerId: number;
  answerText: string;
  isAnswerEditable: boolean;
}

interface SectionData {
  sectionId: number;
  sectionName: string;
  questions: QuestionData[];
}

interface QuestionData {
  questionId: number;
  questionText: string;
  answerText: string;
}

interface QuestionnaireReadOnlyProps {
  userId?: string;
  token?: string;
  userRole?: string;
}

function QuestionnaireReadOnly({
  userId,
  token,
  userRole,
}: QuestionnaireReadOnlyProps) {
  const [formData, setFormData] = useState<SectionData[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (userId && userRole) {
      fetchAnswers();
    }
  }, [userId, userRole]);

  const fetchAnswers = async () => {
    const url = '/form/sections';
    try {
      const jsonData = {
        userId: userId,
        role: userRole,
        documentMode: true,
      };

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify(jsonData),
      });

      if (!response.ok) {
        console.error('Error while fetching data:', response.statusText);
        setIsLoading(false);
        return;
      }

      const data = await response.json();
      const parsedData: SectionNetworkData[] = JSON.parse(data);

      const sectionData = parsedData.map((item) => ({
        sectionId: item.sectionId,
        sectionName: item.sectionName,
        questions: item.questions.map((q) => ({
          questionId: q.questionId,
          questionText: q.questionText,
          answerText: q.answerText,
        })),
      }));

      setFormData(sectionData);
      setIsLoading(false);
    } catch (error) {
      console.error('Error in fetchAnswers:', error);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="QuestionnaireReadOnlyLoading">
        <p>Loading questionnaire...</p>
      </div>
    );
  }

  return (
    <div className="QuestionnaireReadOnlyContainer">
      {formData.map((section) => (
        <div key={section.sectionId} className="QuestionnaireSection">
          <h3 className="SectionTitle">{section.sectionName}</h3>
          <div className="QuestionsList">
            {section.questions.map((question) => (
              <div key={question.questionId} className="QuestionItem">
                <h4 className="QuestionText">{question.questionText}</h4>
                <div className="AnswerText">
                  {question.answerText || 'No answer provided'}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default QuestionnaireReadOnly;


